import { useEffect, useState } from 'react'
import { Tooltip } from '@mui/material'

type TooltipTextProps = {
  text: string
  length?: number
  disableInteractive?: boolean
  placement?: 'bottom' | 'top' | 'left' | 'right'
  slotProps?: any
}

export const TooltipText = ({
  text,
  length = 25,
  disableInteractive,
  placement,
  slotProps,
}: TooltipTextProps) => {
  const [open, setOpen] = useState(false)

  const truncatedValue = () => {
    return `${text.slice(0, length)}${text.length >= length ? '...' : ''}`
  }

  useEffect(() => {
    if (!open) return undefined
    const handleScroll = () => setOpen(false)
    globalThis.addEventListener('scroll', handleScroll, true)
    globalThis.addEventListener('wheel', handleScroll, { capture: true, passive: true })
    globalThis.addEventListener('touchmove', handleScroll, { capture: true, passive: true })
    return () => {
      globalThis.removeEventListener('scroll', handleScroll, true)
      globalThis.removeEventListener('wheel', handleScroll, true)
      globalThis.removeEventListener('touchmove', handleScroll, true)
    }
  }, [open])

  return text?.length > length ? (
    <Tooltip
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      disableInteractive={!!disableInteractive}
      placement={placement || 'bottom'}
      slotProps={slotProps ?? {}}
      componentsProps={{
        tooltip: {
          sx: {
            padding: '0.25rem 0.75rem',
            fontSize: '0.75rem',
            fontWeight: '500',
            lineHeight: '1.5rem',
            width: 'max-content',
          },
        },
      }}
      title={text}
      arrow
    >
      <span data-testid='truncated'>{truncatedValue()}</span>
    </Tooltip>
  ) : (
    <span>{text || ''}</span>
  )
}
